<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มเวลา Lock</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ timezoneInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle> Timezone </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <div>
          <label class="body-2">
            รหัสเวลา Lock
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="timezone.timezone_code"
            :rules="[
              (v) => !!v || 'โปรดระบุรหัสช่วงเวลา',
              (v) =>
                (v && v.length <= 2) || 'รหัสช่วงเวลาต้องน้อยกว่า 2 ตัวอักษร',
            ]"
            outlined
            dense
            required
            clearable
            @change="checkEmpty($event, 'timezone_code')"
          >
          </v-text-field>
        </div>
        <div>
          <label class="body-2">
            คำอธิบาย (ไทย)
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="timezone.title_th"
            :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
            outlined
            dense
            required
            clearable
            @change="checkEmpty($event, 'title_th')"
          >
          </v-text-field>
        </div>
        <div>
          <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="timezone.title_en"
            outlined
            dense
            clearable
            @change="checkEmpty($event, 'title_en')"
          >
          </v-text-field>
        </div>
        <div>
          <tabs @selectedTab="handleSelectedTab" fullWidth>
            <tab
              v-for="timezoneDetail in timezone.timezone_detail"
              :key="timezoneDetail.day_type.day_type_id"
              :title="timezoneDetail.day_type.title_short_th"
            >
              <div class="d-flex align-center justify-space-between pb-3">
                <div class="d-flex align-center">
                  <label class="mr-2">คัดลอกข้อมูล</label>
                  <div style="width: 120px">
                    <v-select
                      v-model="selectDayCopy"
                      style="background-color: white"
                      :items="[
                        { text: '-', value: 0 },
                        { text: 'อาทิตย์', value: 1 },
                        { text: 'จันทร์', value: 2 },
                        { text: 'อังคาร', value: 3 },
                        { text: 'พุธ', value: 4 },
                        { text: 'พฤหัสบดี', value: 5 },
                        { text: 'ศุกร์', value: 6 },
                        { text: 'เสาร์', value: 7 },
                      ]"
                      item-text="text"
                      item-value="value"
                      :item-disabled="
                        (item) =>
                          item.value === timezoneDetail.day_type.day_type_id
                      "
                      hide-details
                      outlined
                      dense
                      @change="
                        handleChangeDayCopy(timezoneDetail.day_type.day_type_id)
                      "
                    ></v-select>
                  </div>
                </div>
                <div>
                  <v-btn
                    depressed
                    color="primary"
                    class="mr-2"
                    :disabled="selectDayCopy === 0"
                    @click="handleCopyDay"
                  >
                    คัดลอก
                  </v-btn>
                  <v-btn
                    depressed
                    color="error"
                    :disabled="selectDayCopy === 0"
                    @click="handleCopyDayCancel"
                  >
                    ยกเลิก
                  </v-btn>
                </div>
              </div>
              <v-divider></v-divider>
              <div class="mt-3">
                <div
                  class="d-flex align-center mb-2"
                  v-for="timezoneTimePeriod in timezoneDetail.timezone_time_period"
                  :key="timezoneTimePeriod.display_order"
                >
                  <!-- <label class="flex-shrink-0 mr-3">
                    ช่วงเวลาที่ {{ index + 1 }}
                  </label> -->
                  <label class="flex-shrink-0 mr-3">
                    ช่วงเวลาที่ {{ timezoneTimePeriod.display_order }}
                  </label>
                  <TimePicker
                    v-model="timezoneTimePeriod.time_period_start"
                    :className="
                      timezoneCurrent
                        ? 'red-text-input centered-input'
                        : 'centered-input'
                    "
                    :disabled="timezoneCurrent ? true : false"
                    :rules="[
                      !timezoneTimePeriod.time_period_start &&
                      timezoneTimePeriod.time_period_end
                        ? false
                        : true,
                    ]"
                  />
                  <!-- <v-text-field
                    v-model="timezoneTimePeriod.time_period_start"
                    style="background-color: white;"
                    class="centered-input"
                    :class="timezoneCurrent ? 'red-text-input' : ''"
                    :disabled="!!timezoneCurrent"
                    hide-details
                    outlined
                    dense
                    v-mask="'##:##'"
                    clearable
                  ></v-text-field> -->
                  <span class="mx-2">-</span>
                  <TimePicker
                    v-model="timezoneTimePeriod.time_period_end"
                    :className="
                      timezoneCurrent
                        ? 'red-text-input centered-input'
                        : 'centered-input'
                    "
                    :disabled="timezoneCurrent ? true : false"
                    :rules="[
                      timezoneTimePeriod.time_period_start &&
                      !timezoneTimePeriod.time_period_end
                        ? false
                        : true,
                    ]"
                  />
                  <!-- <v-text-field
                    v-model="timezoneTimePeriod.time_period_end"
                    style="background-color: white;"
                    class="centered-input"
                    :class="timezoneCurrent ? 'red-text-input' : ''"
                    :disabled="!!timezoneCurrent"
                    hide-details
                    outlined
                    dense
                    v-mask="'##:##'"
                    clearable
                  ></v-text-field> -->
                </div>
              </div>
            </tab>
          </tabs>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isTimezoneDataChange && formAction === 'edit'"
        >
          <v-btn icon @click="onDelete">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn class="primary mr-3" depressed v-else @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'
import TimePicker from '@/components/TimePicker.vue'

export default {
  components: {
    ConfirmDialog,
    Tab,
    Tabs,
    TimePicker,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    timezone: {
      type: Object,
    },
    timezoneInit: {
      type: Object,
    },
  },
  data() {
    return {
      timezoneCurrent: null,
      selectDayCopy: 0,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    isTimezoneDataChange() {
      if (
        this.timezone.timezone_code !== this.timezoneInit.timezone_code ||
        this.timezone.title_th !== this.timezoneInit.title_th ||
        this.timezone.title_en !== this.timezoneInit.title_en ||
        JSON.stringify(this.timezone.timezone_detail) !==
          JSON.stringify(this.timezoneInit.timezone_detail)
      ) {
        this.$emit('isTimezoneDataChange', true)
        return true
      }
      this.$emit('isTimezoneDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addTimezone: 'timezone/addTimezone',
      editTimezone: 'timezone/editTimezone',
      deleteTimezone: 'timezone/deleteTimezone',
    }),
    handleSelectedTab() {
      if (this.timezoneCurrent) {
        this.$emit('onDayCopyCancel', this.timezoneCurrent)
        this.selectDayCopy = 0
        this.timezoneCurrent = null
      }
    },
    handleChangeDayCopy(dayTypeId) {
      this.timezoneCurrent = JSON.parse(JSON.stringify(this.timezone))

      const { timezone_time_period } = this.timezone.timezone_detail.find(
        (item) => item.day_type.day_type_id === this.selectDayCopy
      )

      this.timezone.timezone_detail[dayTypeId - 1].timezone_time_period = [
        ...timezone_time_period,
      ]

      this.$emit('onChangeDayCopy', this.timezone)
    },
    handleCopyDayCancel() {
      this.$emit('onDayCopyCancel', this.timezoneCurrent)
      this.selectDayCopy = 0
      this.timezoneCurrent = null
    },
    handleCopyDay() {
      this.$emit('onDayCopy', this.timezone)
      this.selectDayCopy = 0
      this.timezoneCurrent = null
    },
    checkEmpty(value, field) {
      if (value) {
        this.timezone[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบช่วงเวลา',
        value: `${this.timezone.timezone_code} - ${this.timezone.title_th}`,
        item: this.timezone,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ timezone_uuid }) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        timezone_uuid,
      }

      this.deleteTimezone(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          // this.$refs.form.reset()
          if (this.timezoneCurrent) {
            this.handleSelectedTab()
          } else {
            this.selectDayCopy = 0
          }
          this.$emit('formActionCompleted', this.formAction)
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          if (this.selectDayCopy !== 0) return

          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: {
              timezone_code: this.timezone.timezone_code,
              title_th: this.timezone.title_th,
              title_en: this.timezone.title_en || undefined,
              timezone_detail: this.timezone.timezone_detail.map((item) => ({
                day_type_id: item.day_type.day_type_id,
                timezone_time_period: item.timezone_time_period,
              })),
            },
          }

          await this.addTimezone(payload)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          // this.$refs.form.reset()
          if (this.timezoneCurrent) {
            this.handleSelectedTab()
          } else {
            this.selectDayCopy = 0
          }
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          if (this.selectDayCopy !== 0) return

          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            timezone_uuid: this.timezone.timezone_uuid,
            body: {
              timezone_code: this.timezone.timezone_code,
              title_th: this.timezone.title_th,
              title_en: this.timezone.title_en || undefined,
              timezone_detail: this.timezone.timezone_detail.map((item) => ({
                day_type_id: item.day_type.day_type_id,
                timezone_time_period: item.timezone_time_period,
              })),
            },
          }

          await this.editTimezone(payload)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          // this.$refs.form.reset()
          if (this.timezoneCurrent) {
            this.handleSelectedTab()
          } else {
            this.selectDayCopy = 0
          }
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          this.$store.state.loading = false

          if (error.response && error.response.data) {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: 4000,
              message: error.response.data.message || 'Something went wrong!',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            // this.$refs.form.reset()
            if (this.timezoneCurrent) {
              this.handleSelectedTab()
            } else {
              this.selectDayCopy = 0
            }
            this.$emit('formActionCompleted', this.formAction)
          } else {
            const snackbar = {
              show: true,
              color: 'error',
              timeout: 4000,
              message: 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          }
        }
      }
    },
    onClose() {
      if (this.isTimezoneDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        // this.$refs.form.reset()
        if (this.timezoneCurrent) {
          this.handleSelectedTab()
        } else {
          this.selectDayCopy = 0
        }
        this.$emit('formActionCompleted', this.formAction)
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      // this.$refs.form.reset()
      if (this.timezoneCurrent) {
        this.handleSelectedTab()
      } else {
        this.selectDayCopy = 0
      }
      this.$emit('formActionCompleted', this.formAction)
    },
    onReset() {
      this.$refs.form.resetValidation()
      // this.$refs.form.reset()
      if (this.timezoneCurrent) {
        this.handleSelectedTab()
      } else {
        this.selectDayCopy = 0
      }
      this.$emit('formActionCompleted', this.formAction)
    },
  },
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}

.red-text-input >>> input {
  color: red;
}
</style>
